export default "__VITE_ASSET__Cl2Wuhqq__"